import ApiBase from "./ApiBase";

class VersionApi {
  fetch(query, rule = "complete_active") {
    return ApiBase.get("/version");
  }
}

export default new VersionApi();
